module.exports = __webpack_public_path__ + "static/media/Recomposition_05@2x.075c0459.png";